module.exports = __webpack_public_path__ + "static/media/single-right-blue.17d6ce85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/single-right-blue.svg
// module id = 3225
// module chunks = 0